import { useNavigate } from "react-router-dom";
const videoHome = require("../../assets/videos/video_home_reel.mp4");

const list_funcionalidades = [
    {
        text: "Automatiza tareas y ahorra tiempo con nuestra plataforma.",
    },
    {
        text: "Aumenta ocupación y ingresos con estrategias de marketing.",
    },
    {
        text: "Controla tus finanzas y genera informes detallados para tomar decisiones.",
    },

    {
        text: "Comunícate fácilmente con tus inquilinos y ofrece un servicio al cliente.",
    },
    {
        text: "Accede a tu información desde cualquier lugar y en cualquier momento.",
    },
];

const Funcionalidades = () => {
    const navigate = useNavigate();
    return (
        <div className="w-full bg-[#E7E8EA] bg-opacity-20 2xl:pb-10 pb-5 ">
            <div className="flex flex-col items-center justify-center  mx-auto mb-10 3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6  ">
                <div className="flex lg:flex-row flex-col items-center justify-center  mx-auto mt-2   ">
                    <div className="grid w-full grid-cols-1 lg:w-3/5  ">
                        <div className="text-[#071829] 2xl:text-4xl xl:text-3xl text-2xl font-bold text-center lg:text-left  ">
                            La solución integral que impulsa tu negocio
                            inmobiliario al máximo
                        </div>

                        <div className="text-[#071829] 2xl:text-xl xl:text-base lg:text-base md:text-sm text-xs  mt-5 mb-6 text-center lg:text-left  ">
                            Gestiona tus alquileres de forma eficiente y sin
                            complicaciones
                        </div>

                        {list_funcionalidades.map((funcionalidad) => (
                            <div className="flex w-full my-1  ">
                                <div className=" rounded-lg flex justify-center items-center   ">
                                    <svg
                                        width="22"
                                        height="22"
                                        viewBox="0 0 28 28"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M23.3333 28H4.66667C2.08911 28 0 25.9109 0 23.3333V4.66667C0 2.08911 2.08911 0 4.66667 0H23.3333C25.9109 0 28 2.08911 28 4.66667V23.3333C28 25.9109 25.9109 28 23.3333 28Z"
                                            fill="#C3EA43"
                                        />
                                        <path
                                            d="M12.4001 20C11.9905 20 11.5809 19.846 11.2689 19.5396L6.46918 14.8255C5.84361 14.2111 5.84361 13.218 6.46918 12.6036C7.09475 11.9891 8.10589 11.9891 8.73146 12.6036L12.4001 16.2067L19.2685 9.4608C19.8941 8.8464 20.9053 8.8464 21.5308 9.4608C22.1564 10.0752 22.1564 11.0683 21.5308 11.6827L13.5312 19.5396C13.2192 19.846 12.8097 20 12.4001 20Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="flex flex-col w-full gap-1">
                                    <div className="2xl:text-xl xl:text-base  md:text-sm text-xs text-[#0E1928]  px-5 p-1 ">
                                        {funcionalidad.text}
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div
                            onClick={() => {
                                window.open(
                                    "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                                );
                            }}
                            className="w-fit xl:text-base text-sm mx-auto lg:mx-0  flex justify-center items-center gap-2 rounded-lg text-[#071829] px-4 py-2 bg-gradient-to-r from-[#C3EA43] to-[#E3FF89] mt-5 hover:scale-105 cursor-pointer "
                        >
                            Agenda tu demo
                            <svg
                                className="text-[#071829]"
                                width="12"
                                height="13"
                                viewBox="0 0 16 17"
                                fill="071829"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.375 16.125C5.05859 16.125 4.77734 16.0195 4.56641 15.8086C4.10938 15.3867 4.10938 14.6484 4.56641 14.2266L10.5078 8.25L4.56641 2.30859C4.10938 1.88672 4.10938 1.14844 4.56641 0.726562C4.98828 0.269531 5.72656 0.269531 6.14844 0.726562L12.8984 7.47656C13.3555 7.89844 13.3555 8.63672 12.8984 9.05859L6.14844 15.8086C5.9375 16.0195 5.65625 16.125 5.375 16.125Z"
                                    fill="071829"
                                />
                            </svg>{" "}
                        </div>
                    </div>
                    <div className="flex flex-col justify-between w-full 2xl:h-[600px] lg:h-[500px] h-[450px] mt-0 lg:w-2/5 md:mt-3">
                        <div className="2xl:h-[600px] lg:h-[500px] h-[450px] ">
                            <video
                                loop
                                className="w-auto 2xl:h-[600px] lg:h-[500px] h-[450px] mx-auto rounded-xl"
                                src={videoHome}
                                controls
                                controlsList="nodownload"
                            ></video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Funcionalidades;
